import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fe4cfe2"
import script from "./icon.js?vue&type=script&lang=js&external"
export * from "./icon.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports